var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "recipients" },
    [
      _c("TMSHeader", {
        attrs: {
          title: _vm.currentECircular.subject || "--",
          buttons: _vm.buttons,
          status: _vm.currentECircular.status,
          dotOption: _vm.dotOption,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "recipients-content" }, [
        _c(
          "div",
          { staticClass: "search-arrow-area" },
          [
            _c(
              "TabsContainer",
              {
                key: _vm.tabNames.length,
                staticClass: "tabs-container-wrapper",
                attrs: { tabNames: _vm.tabNames },
              },
              [
                _vm.isMarketingECircular
                  ? _c(
                      "div",
                      {
                        staticClass: "search-area_marketing",
                        attrs: { slot: _vm.tabContainersIdMap["marketing"] },
                        slot: _vm.tabContainersIdMap["marketing"],
                      },
                      [
                        _c("div", { staticClass: "search-condition" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "zone medium-6 small-6 large-6 columns",
                            },
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("tenancy.zone"))),
                              ]),
                              _vm._v(" "),
                              _c("HKLSelect", {
                                attrs: {
                                  options: _vm.zoneHklOptions,
                                  value: _vm.marketingParams.zone || undefined,
                                  placeholder: "",
                                  showSearch: true,
                                },
                                on: {
                                  change: function (val) {
                                    return _vm.updateZone(
                                      val,
                                      "marketingParams"
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "marketing-type medium-6 small-6 large-6 columns",
                            },
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("tenancy.marketingType"))),
                              ]),
                              _vm._v(" "),
                              _c("HKLMultiSelect", {
                                staticClass: "multi-value",
                                attrs: {
                                  options: _vm.marketingHklOptions,
                                  value: _vm.marketingParams.marketingTypes,
                                  placeholder: "",
                                },
                                on: { change: _vm.onMarketingTypesChange },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "trade-name medium-12 small-12 large-12 columns",
                            },
                            [
                              _c("label", [
                                _vm._v(_vm._s(_vm.$t("eCircular.tradeName"))),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "search-input" }, [
                                _c("input", {
                                  staticClass: "input-field",
                                  attrs: { placeholder: "" },
                                  domProps: {
                                    value: _vm.marketingParams.tradeName,
                                  },
                                  on: {
                                    change: function (val) {
                                      return _vm.updateTradeName(
                                        val,
                                        "marketingParams"
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn--darkblue",
                                    attrs: {
                                      disabled: _vm.isMarketingSearchDisabled,
                                      role: "search",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm._searchRecipients(true)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("action.search")) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "search-result" },
                          [
                            _c("SelectRecipients", {
                              ref: "select-marketing-recipients",
                              attrs: {
                                operate: "ADD",
                                showMarketingType: true,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "search-area",
                    attrs: { slot: _vm.tabContainersIdMap["ecircular"] },
                    slot: _vm.tabContainersIdMap["ecircular"],
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "search-condition" },
                      [
                        _vm.isTenantOrTenancyEcircular
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "zone medium-6 small-6 large-6 columns",
                                },
                                [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("tenancy.zone"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("HKLSelect", {
                                    attrs: {
                                      options: _vm.zoneHklOptions,
                                      value:
                                        _vm.pmCircularParams.zone || undefined,
                                      placeholder: "",
                                      showSearch: true,
                                    },
                                    on: {
                                      change: function (val) {
                                        return _vm.updateZone(
                                          val,
                                          "pmCircularParams"
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.isTenantEcircular
                                ? _c(
                                    "div",
                                    { staticClass: "floor" },
                                    [
                                      _c("label", [
                                        _vm._v(_vm._s(_vm.$t("tenancy.floor"))),
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.pmCircularParams.floorFromToPair,
                                        function (pair, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              class: [
                                                "floorFromToPair",
                                                { "error-highlight": pair.err },
                                              ],
                                            },
                                            [
                                              _c("HKLSelect", {
                                                attrs: {
                                                  options: _vm.floorHklOptions,
                                                  value: pair.from || undefined,
                                                  placeholder: "",
                                                  showSearch: true,
                                                },
                                                on: {
                                                  change: function (val) {
                                                    return _vm.updateFloorFromToPair(
                                                      val,
                                                      index,
                                                      "from"
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "dash" },
                                                [_vm._v("-")]
                                              ),
                                              _vm._v(" "),
                                              _c("HKLSelect", {
                                                attrs: {
                                                  options: _vm.floorHklOptions,
                                                  value: pair.to || undefined,
                                                  placeholder: "",
                                                  showSearch: true,
                                                },
                                                on: {
                                                  change: function (val) {
                                                    return _vm.updateFloorFromToPair(
                                                      val,
                                                      index,
                                                      "to"
                                                    )
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              pair.to ||
                                              pair.from ||
                                              _vm.pmCircularParams
                                                .floorFromToPair.length > 1
                                                ? _c("i", {
                                                    staticClass: "fa-times fa",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.deleteOnePair(
                                                          index
                                                        )
                                                      },
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "pair-operate" },
                                        [
                                          _c("i", {
                                            staticClass: "fa-plus fa",
                                            on: { click: _vm.addOnePair },
                                          }),
                                        ]
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "user-type-field medium-6 small-6 large-6 columns",
                                },
                                [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("userType.name"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("HKLMultiSelect", {
                                    staticClass: "multi-value",
                                    attrs: {
                                      options: _vm.userTypeOpts,
                                      value: _vm.selectedUserContactTypes,
                                      placeholder: "",
                                      showSearch: true,
                                    },
                                    on: {
                                      change: _vm.onUserContactTypesChange,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "trade-name medium-12 small-12 large-12 columns",
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(_vm.$t("eCircular.tradeName"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "search-input" }, [
                                    _c("input", {
                                      staticClass: "input-field",
                                      attrs: { placeholder: "" },
                                      domProps: {
                                        value: _vm.pmCircularParams.tradeName,
                                      },
                                      on: {
                                        change: function (val) {
                                          return _vm.updateTradeName(
                                            val,
                                            "pmCircularParams"
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn--darkblue",
                                        attrs: {
                                          disabled:
                                            _vm.isPmCircularSearchDisabled,
                                          role: "search",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm._searchRecipients(false)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.$t("action.search")) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isVendorEcircular
                          ? [
                              _c("VendorRecipientsSearch", {
                                ref: "vendor-recipients-search",
                                attrs: {
                                  initSelectRecipientsTree:
                                    _vm.initSelectRecipientsTree,
                                },
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "search-result" },
                      [
                        _c("SelectRecipients", {
                          ref: "select-recipients",
                          attrs: { operate: "ADD", showMarketingType: false },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "arrow-area" }, [
              _c(
                "button",
                {
                  staticClass: "btn--darkblue",
                  attrs: { role: "add-recipients" },
                  on: { click: _vm.addToAddedRecipients },
                },
                [_vm._v("\n          >>\n        ")]
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "selected-recipients" },
          [
            _c("p", { staticClass: "title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("eCircular.selectedRecipients")) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mount-recipients" }, [
              _c("span", { staticClass: "item" }, [
                _c("span", { staticClass: "tip" }, [
                  _vm._v(_vm._s(_vm.organizationNumber)),
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("eCircular.organizations")))]),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "item" }, [
                _c("span", { staticClass: "tip" }, [
                  _vm._v(_vm._s(_vm.recipientsNumber)),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("eCircular.recipientsSelected"))),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("SelectRecipients", {
              ref: "delete-recipients",
              attrs: {
                operate: "DEL",
                showMarketingType: _vm.isMarketingECircular,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.currentECircular.id
        ? _c("PreviewECircular", {
            ref: "previewECircular",
            attrs: { previewType: _vm.PREVIEW_TYPES.SEND },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("CancelECircular", { ref: "ecircular-cancel-modal" }),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "filterRemoveConfirmModal",
        staticClass: "ecircular-modal",
        attrs: {
          modalId: _vm.filterRemoveConfirmModalId,
          "confirm-title": "eCircular.confirmRemoveUserTypeBody",
          "modal-type": "small-modal",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }